import React from 'react';
import { B } from '../constants';
import { GBWordmark } from './Logo';

export default function Footer({ goScreen = () => {} }) {
  return (
    <footer style={{ background: B.night, padding: '48px clamp(16px, 4vw, 40px)', color: 'white' }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(200px, 100%), 1fr))', gap: 32, maxWidth: 1200, margin: '0 auto' }}>
        
        {/* Column 1: Logo */}
        <div>
          <GBWordmark size="sm" />
          <p style={{ color: '#999', fontSize: 13, marginTop: 12, marginBottom: 16, lineHeight: 1.6 }}>
            AI-powered trip planning for modern travelers.
          </p>
        </div>
        
        {/* Column 2: Company */}
        <div>
          <h4 style={{ fontFamily: "'Montserrat',sans-serif", fontSize: 14, fontWeight: 700, marginBottom: 16 }}>Company</h4>
          <div onClick={() => { window.location.href = '/about'; }} style={{ color: '#999', fontSize: 13, marginBottom: 8, cursor: 'pointer' }}>About</div>
        </div>
        
        {/* Column 4: Legal */}
        <div>
          <h4 style={{ fontFamily: "'Montserrat',sans-serif", fontSize: 14, fontWeight: 700, marginBottom: 16 }}>Legal</h4>
          {['Privacy', 'Terms'].map(link => (
            <div key={link} onClick={() => {
              if (link === 'Privacy') window.location.href = '/privacy';
              else if (link === 'Terms') window.location.href = '/terms';
            }} style={{ color: '#999', fontSize: 13, marginBottom: 8, cursor: 'pointer' }}>{link}</div>
          ))}
        </div>
      </div>
    
      {/* Bottom Row */}
      <div style={{ borderTop: '1px solid rgba(255,255,255,0.1)', marginTop: 32, paddingTop: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16 }}>
        <p style={{ color: '#777', fontSize: 12 }}>© 2026 GreatBreak Travel. Made with ♥ for explorers everywhere.</p>
      </div>
    </footer>
  );
}
